export const classes = {
  toggleBlock: 'gap-[2px] rounded-full p-[3px]',
  option:
    'rounded-full px-3 py-1 text-[11.5px] aria-pressed:shadow-[0_4px_10px_-3px_rgba(241,90,43,0.42)]',
};

export const styles = {
  option: {
    '&.MuiToggleButtonGroup-grouped': {
      border: 'none',
      margin: 0,
      borderRadius: '9999px',
    },
  },
};
